"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.SearchActions = void 0;
var SearchActions;
exports.SearchActions = SearchActions;

(function (SearchActions) {
  SearchActions["searchChanged"] = "@app/search/changed";
  SearchActions["executeSearch"] = "@app/search/execute";
  SearchActions["searchFailed"] = "@app/search/failed";
  SearchActions["clearSearch"] = "@app/search/clear";
  SearchActions["addSuggestions"] = "@app/search/suggestions/add";
  SearchActions["addPersona"] = "@app/search/persona/add";
  SearchActions["removePersona"] = "@app/search/persona/remove";
  SearchActions["showFilter"] = "@app/search/filter/show";
  SearchActions["hideFilter"] = "@app/search/filter/hide";
  SearchActions["selectFilterKey"] = "@app/search/filter/select-key";
  SearchActions["setSelectedSuggestionIndex"] = "@app/search/suggestions/set-selected-index";
  SearchActions["setSearchTextForSuggestion"] = "@app/search/suggestions/suggest-text";
  SearchActions["selectSuggestionByIndex"] = "@app/search/suggestions/select-by-index";
  SearchActions["addKeywordSuggestion"] = "@app/search/suggestions/add-keyword";
  SearchActions["toggleSaveSearch"] = "@app/search/suggestions/save";
  SearchActions["searchUsers"] = "@app/search/user/search";
  SearchActions["setSearchContext"] = "@app/search/context/set";
})(SearchActions || (exports.SearchActions = SearchActions = {}));